'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$() {
  this.aHG = null;
  this.aHX = null;
  this.aHJ = null;
  this.aHK = false;
  this.aHP = null;
  this.aHQ = false;
  this.aHV = null;
  this.aHW = false;
  this.aHH = null;
  this.aHI = false;
  this.aHT = null;
  this.aHU = false;
  this.aHR = null;
  this.aHS = false;
  this.aHL = null;
  this.aHM = false;
  this.aHN = null;
  this.aHO = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$ = this;
  this.aHG = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$();
  this.aHX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$.prototype = $p;
$p.eR = (function() {
  return this.aHG;
});
$p.eO = (function() {
  return this.aHX;
});
$p.bW = (function() {
  if ((!this.aHK)) {
    this.aHJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aHK = true;
  }
  return this.aHJ;
});
$p.b9 = (function() {
  if ((!this.aHQ)) {
    this.aHP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aHQ = true;
  }
  return this.aHP;
});
$p.b3 = (function() {
  if ((!this.aHW)) {
    this.aHV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aHW = true;
  }
  return this.aHV;
});
$p.aG = (function() {
  if ((!this.aHI)) {
    this.aHH = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aHI = true;
  }
  return this.aHH;
});
$p.az = (function() {
  if ((!this.aHU)) {
    this.aHT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aHU = true;
  }
  return this.aHT;
});
$p.aY = (function() {
  if ((!this.aHS)) {
    this.aHR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aHS = true;
  }
  return this.aHR;
});
$p.yo = (function() {
  if ((!this.aHM)) {
    this.aHL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Consignee";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aHM = true;
  }
  return this.aHL;
});
$p.asr = (function() {
  if ((!this.aHO)) {
    this.aHN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aHO = true;
  }
  return this.aHN;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$, "app.data.data_point_types$package$ConsigneeForm$", ({
  Fz: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$() {
  this.aHE = null;
  this.aHF = false;
  this.aHC = null;
  this.aHD = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$.prototype = $p;
$p.aA = (function() {
  if ((!this.aHF)) {
    this.aHE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aHF = true;
  }
  return this.aHE;
});
$p.ash = (function() {
  if ((!this.aHD)) {
    this.aHC = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$().yo();
    this.aHD = true;
  }
  return this.aHC;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$, "app.data.data_point_types$package$Consignee$", ({
  Fy: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Consignee$ };
//# sourceMappingURL=app.data.data_point_types$package$-Consignee$.js.map
